import React, { useEffect } from "react";

import Container from "@mui/material/Container";
import CreatorAdminDashboard from "./CreatorAdminDashboard";
import CreatorUserDashboard from "./CreatorUserDashboard";
import { useDispatch, useSelector } from "react-redux";
import { isBlank, notBlank } from "../../util/ext";
import { logOut } from "../../auth/authActions";
import { hasAnyRole, hasRole } from "../../auth/authUtils";
import Unauthorized from "../../auth/Unauthorized";

const UnauthorizedAccess = () => {
  return (
    <Unauthorized message="You do not have the proper access rights to the Creator Application" />
  );
};

const showUserDashboard = auth =>
  notBlank(auth.currentOrganization) &&
  hasAnyRole(auth.currentOrganization, [
    "ROLE_CREATOR_USER",
    "ROLE_CREATOR_MANAGER",
    "ROLE_CONTENT_MANAGER",
  ]);

const showAdminDashboard = auth => hasRole(auth.user, "ROLE_ADMIN");

const DashboardView = () => {
  // const classes = useStyles();
  const reduxDispatch = useDispatch();
  const auth = useSelector(state => state.auth);

  useEffect(() => {
    if (isBlank(auth)) {
      reduxDispatch(logOut());
    }
  }, [auth, reduxDispatch]);

  return (
    <Container id="dashboard-view" disableGutters>
      {showUserDashboard(auth) ? (
        <CreatorUserDashboard />
      ) : showAdminDashboard(auth) ? (
        <CreatorAdminDashboard />
      ) : (
        <UnauthorizedAccess />
      )}
    </Container>
  );
};

export default DashboardView;
